import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { installationConfig } from "@/shared/constants/installation-config";
import type { InitOptions } from "i18next";
import { LANGUAGE_KEY, languageList } from "./slice/types";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true, // env
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    lng: localStorage.getItem(LANGUAGE_KEY) || installationConfig.langKey,
    supportedLngs: languageList,
  } as InitOptions);

export default i18n;
